import React , { useState } from 'react'
export const CurrentPage = React.createContext('')
export const UserValues = React.createContext('')
export const UserErrors = React.createContext('')
export const UserButtons = React.createContext('')

function Context({children}) {

    const [ currentPageState , setCurrentPageState ] = useState('RegionPage')
    const [ userValuesState , setuserValuesState  ] = useState({ regionLink : '' , regionName : '' , regionNumber : '' , log : '' , pass : '' , number : '' , idClient : 0 })
    const [ userErrorsState , setuserErrorsState ] = useState({ regionPageError : false , logPageError : false ,  passPageError : false , numberError : false   })
    const [ userButtonsState , setuserButtonsState ] = useState({ RegionPageButtonDisabled : false , LogPageButtonDisabled : false , PassPageButtonDisabled : false , NumberPageButtonDisabled : false})

    return (
        <CurrentPage.Provider value={[currentPageState , setCurrentPageState]} >
            <UserValues.Provider value={[ userValuesState , setuserValuesState  ]} >
                <UserErrors.Provider value={[ userErrorsState , setuserErrorsState ]} >
                    <UserButtons.Provider value={[ userButtonsState , setuserButtonsState ]} >
                        {children}
                    </UserButtons.Provider>
                </UserErrors.Provider>
            </UserValues.Provider>
        </CurrentPage.Provider>
    )
}

export default Context